import { render, staticRenderFns } from "./UpgradeSuggester.vue?vue&type=template&id=a86a97b8&"
import script from "./UpgradeSuggester.vue?vue&type=script&lang=js&"
export * from "./UpgradeSuggester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports